import { OfficeButton, Show, TextLoader } from 'components'

import { TreatyType } from '_graphql/__generated__/globalTypes';
import { Treaty_treaty } from '_graphql/queries/__generated__/Treaty';
import { useAppNavigate } from '_graphql/cache/auth';

type Props = {
    isProportional: boolean;
    loading: boolean;
    treaty: Treaty_treaty | null | undefined
}

const TreatyDetails = ({ isProportional, loading, treaty }: Props) => {
    const navigate = useAppNavigate();
    const hasParticipants = Boolean(treaty?.treaty_participants && treaty?.treaty_participants?.length > 0);

    const currency = treaty?.treaty_program?.treaty_type === TreatyType.NONPROPORTIONAL ? treaty?.currency : JSON.parse(treaty?.treaty_details ?? "[]")?.find(
        (el: any) => el.keydetail.toLowerCase() === "currency"
    )?.value;


    return (
        <div className="bg-card-500 rounded-xl shadow-lg overflow-hidden">
            <div className="px-6 py-5 border-b border-gray-700/50">
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="text-xl font-semibold text-primary">Treaty Information</h3>
                        <p className="mt-1 text-sm text-tertiary">Details and information about the treaty</p>
                    </div>
                    <div className="flex gap-3">
                        <OfficeButton
                            size="sm"
                            onClick={() => navigate({
                                to: `${treaty?.treaty_reference?.replaceAll("/", "__")}/manage-treaty`,
                                search: (prev) => ({ ...prev }),
                            })}
                        >
                            Manage Treaty
                        </OfficeButton>
                        <Show if={isProportional}>
                            <OfficeButton
                                size="sm"
                                disabled={!hasParticipants}
                                onClick={() => navigate({
                                    search: (prev) => ({ ...prev, modal: "clone" }),
                                })}
                            >
                                Duplicate Treaty
                            </OfficeButton>
                        </Show>
                    </div>
                </div>
            </div>

            <div className="p-6">
                <dl className="grid grid-cols-1 sm:grid-cols-4 gap-6">
                    <TextLoader
                        label="Treaty Program"
                        value={treaty?.treaty_program?.treaty_name || ""}
                        loading={loading}
                    />
                    <TextLoader
                        label="Reference No."
                        value={treaty?.treaty_reference || ""}
                        loading={loading}
                    />
                    <TextLoader
                        label="Ceding Company"
                        value={treaty?.insurer?.insurer_company_name || ""}
                        loading={loading}
                    />
                    <TextLoader
                        label="Period"
                        value={`${treaty?.treaty_deduction?.treaty_period_from} to ${treaty?.treaty_deduction?.treaty_period_to}` || ""}
                        loading={loading}
                    />
                    <TextLoader
                        label="Brokerage"
                        value={`${treaty?.treaty_deduction?.brokerage || 0}%`}
                        loading={loading}
                    />
                    <TextLoader
                        label="NIC Levy"
                        value={`${treaty?.treaty_deduction?.nic_levy || 0}%`}
                        loading={loading}
                    />
                    <TextLoader
                        label="Withholding Tax"
                        value={`${treaty?.treaty_deduction?.withholding_tax || 0}%`}
                        loading={loading}
                    />
                    <TextLoader
                        label="Currency"
                        value={currency || "n/A"}
                        loading={loading}
                    />
                </dl>
            </div>
        </div>
    )
}

export default TreatyDetails